module.exports = __webpack_public_path__ + "img/eggsport-t.a6dc6ce0.gif";